module.exports = __webpack_public_path__ + "static/fonts/iconfont.7b9ccf3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/comm/font/iconfont.ttf?t=1653981484471
// module id = 9+Vl
// module chunks = 66